import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noConsecutiveDigitsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const strValue = value.toString();

    const allSameDigits = /^(\d)\1+$/.test(strValue);

    return allSameDigits ? { consecutiveDigits: true } : null;
  };
}